export default {
      id: "i-calendar2-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "img/sprite.svg#i-calendar2",
      toString: function () {
        return this.url;
      }
    }